/**
 * ARQUIVO ATUALIZADO (CORREÇÃO FINAL)
 * Caminho: src/firebase/messaging.js
 * Descrição: O código foi atualizado para inicializar corretamente o serviço
 * de mensagens (getMessaging) e registrar o service worker, o que é
 * necessário para que o pop-up de permissão seja exibido.
 */
import { getMessaging, getToken, isSupported } from "firebase/messaging";
import { doc, updateDoc } from 'firebase/firestore';
import { db } from './config';
import { app } from './config'; // Importa a 'app' inicializada

// <<-- 1. INICIALIZAÇÃO DO MESSAGING -->>
// É crucial verificar suporte antes de inicializar para evitar erros em navegadores incompatíveis.
let messaging = null;

const initializeMessaging = async () => {
  try {
    const supported = await isSupported();
    if (supported) {
      messaging = getMessaging(app);
    } else {
      console.warn("Este navegador não suporta Firebase Messaging.");
    }
  } catch (err) {
    console.error("Erro ao verificar suporte de Messaging:", err);
  }
};

initializeMessaging();

/**
 * Solicita permissão para notificações e salva o token no Firestore.
 * @param {object} user - O objeto do usuário (deve conter uid e role).
 */
export const requestNotificationPermission = async (user) => {
  if (!user || !user.uid || !user.role) {
    console.log("Usuário inválido. Abortando pedido de permissão.");
    return;
  }
  // Garante que o messaging foi inicializado
  if (!messaging) return;

  console.log('Solicitando permissão para notificações...');
  
  try {
    const permission = await Notification.requestPermission();
    
    if (permission === 'granted') {
      console.log('Permissão para notificações concedida.');
      
      const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY;

      if (!vapidKey) {
        console.error("Chave VAPID não encontrada. Verifique o arquivo .env.");
        return;
      }
      
      const currentToken = await getToken(messaging, { vapidKey: vapidKey });
      
      if (currentToken) {
        console.log('Token FCM obtido:', currentToken);
        
        const collectionName = user.role === 'Paciente' ? 'patients' : 'users';
        const userDocRef = doc(db, collectionName, user.uid);

        await updateDoc(userDocRef, { fcmToken: currentToken });
        console.log('Token FCM salvo com sucesso para o usuário:', user.uid);

      } else {
        console.log('Nenhum token de registro disponível. Solicite a permissão para gerar um.');
      }
    } else {
      console.log('Não foi possível obter permissão para notificar.');
    }
  } catch (error) {
    console.error('Ocorreu um erro ao obter o token.', error);
  }
};